const names = {
  accentBlue: '--color-accent-blue',
  oldBlue: '--color-old-blue',
  blue: '--color-blue',
  bluePurple: '--color-blue-purple',
  body: '--color-body',
  danger: '--color-danger',
  gray: '--color-gray',
  grey9: '--color-grey-9',
  grayLight: '--color-gray-light',
  grayLighter: '--color-gray-lighter',
  darkGray: '--color-dark-gray',
  green: '--color-green',
  greenLighter: '--color-green-lighter',
  lightBlue: '--color-light-blue',
  orange: '--color-orange',
  orangeLighter: '--color-orange-lighter',
  palePurple: '--color-pale-purple',
  palePurpleLight: '--color-pale-purple-light',
  red: '--color-red',
  redLight: '--color-red-light',
  rose: '--color-rose',
  skyBlue: '--color-sky-blue',
  instachampPurple: '--color-instachamp-purple',
};

const base = Object.create(null);
Object.assign(base, names);

const handler = {
  get: (target: object, prop: string) => {
    if (!Reflect.has(target, prop)) return '';
    return getComputedStyle(document.body).getPropertyValue(
      Reflect.get(target, prop),
    );
  },
  set: () => false,
};

const colorFactory = (): Record<keyof typeof names, string> => {
  return new Proxy(base, handler);
};

export const colors = colorFactory();

export type ColorType = 'neutral' | 'info' | 'warning' | 'error' | 'success';

// [backgroundColor, contentColor, borderColor]
const getColorsByType = (type: ColorType = 'info') => {
  const colorsPerType: Record<ColorType, string[]> = {
    neutral: [colors.grayLighter, colors.palePurple, colors.palePurpleLight],
    info: [colors.lightBlue, colors.blue, colors.blue],
    warning: [colors.orangeLighter, colors.orange, colors.orange],
    success: [colors.greenLighter, colors.green, colors.green],
    error: [colors.rose, colors.red, colors.redLight],
  };
  return colorsPerType[type];
};

export const getColorStylesByType = (type: ColorType = 'info') => {
  const [backgroundColor, color, borderColor] = getColorsByType(type);
  return { backgroundColor, borderColor, color };
};
